module.exports = __webpack_public_path__ + "img/icon_t17.9a5d3cd4.png";